<template>
<div>
  <LazySignModal v-if="showLegalModal" />
  <TokenExpiryModal />
  <BusinessSwitchOverlay />
  <client-only>
    <div v-if="gtm">
      <!-- Google Tag Manager (noscript) -->
      <noscript id="google-tags"><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P6PJHT"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    </div>
  </client-only>
</div>
</template>

<script>
import { LazySignModal } from '#components'
import { mapActions, mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useAppAnalyticsStore } from '~/store/app-analytics'
import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'
import { get } from 'es-toolkit/compat'
import TokenExpiryModal from '~/components/TokenExpiryModal.vue'
import BusinessSwitchOverlay from '~/components/BusinessSwitchOverlay.vue'

/**
 * Include this component in any new vue layouts (excluding legacy)
 * Add any shared code here that should exist in all layouts
 */
export default {
  components: {
    LazySignModal,
    TokenExpiryModal,
    BusinessSwitchOverlay,
  },
  watch: {
    '$route.path'() {
      useAppAnalyticsStore().dreamsSetEvent({ name: this.$route.path, value: true })
    },
  },
  props: {
    gtm: {
      type: Boolean,
      default: true
    }
  },
  async setup() {
    const rootStore = useRootStore()
    const userStore = useUserStore()
    const affiliateCustomizationsStore = useAffiliateCustomizationStore()
    const borrowerStore = useBorrowerStore()
    const { showLegalModal } = storeToRefs(borrowerStore)
    rootStore.setPageTitle(affiliateCustomizationsStore.headTitlePrefix + ' - Portal')
    rootStore.setLendioFavicons()

    useHead({
      title: rootStore.pageTitle,
      link: rootStore.favicons,
    })

    return {
      showLegalModal,
      rootStore,
      userStore,
    }
  },
  computed: {
    ...mapState(useRootStore, [
      'pageTitle',
      'authUser',
    ]),
    ...mapState(useBorrowerStore, {
      borrower: store => get(store, 'borrower', null),
      borrowerId: store => get(store, 'borrowerId', null)
    }),
    lendioId() {
      return get(window, 'dreams.dataLayer.user.lendioId', null)
    },
  },
  methods: {
    ...mapActions(useRootStore, [
      'setPageTitle',
      'setLendioFavicons',
      'setBlankFavicons'
    ]),
  },
  async mounted() {
    if (this.canUseEmbedded && window.lendio && !window.lendio.hasIdentified) {
      const embeddedInitBody = this.rootStore.getEmbeddedInitBody
      window.lendio.initialize(embeddedInitBody)
    }

    await this.userStore.loadFreshLogin()
  },
}
</script>

<style lang="scss">
@import 'lendio-modals';

.btn.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(5, 194, 240, 0.5) !important;
}
.btn.btn-primary.next-save {
  box-shadow: none !important;
}
</style>
